const dateFiler = (
  date?: string | null,
  options: Intl.DateTimeFormatOptions = {
    dateStyle: 'medium',
  },
): string | undefined => {
  if (date === null || date === undefined) { return undefined };

  const parsedDate = new Date(date);

  return new Intl.DateTimeFormat('en', options).format(parsedDate);
};

export { dateFiler };
export default dateFiler;
